import SelectionCalendar from "./-selectionCalendar";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/opr/selectionCalendar")({
  staticData: {
    menuLabel: "推品日历",
    showInMenu: true,
    menuGroup: "/opr",
    menuOrder: 1,
  },
  component: SelectionCalendar,
});
